import React from 'react';

export const AddFreeSampleIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 1"
      viewBox="0 0 55 49"
      {...props}
    >
      <g data-name="Continue Button">
        <rect
          data-name="Rectangle 82"
          width={55}
          height={49}
          rx={10}
          fill="#fad406"
        />
      </g>
      <path
        data-name="Path 3129"
        d="M23.69 32.21l12.22.1a3.15 3.15 0 002.93-2L44 17.79a1.46 1.46 0 00-1.34-2H18.54l-.24-.57a3.82 3.82 0 00-3.57-2.41h-3.16a1.45 1.45 0 00-1.45 1.45 1.45 1.45 0 001.45 1.46h3.16a.92.92 0 01.87.59l5.78 14.14-3.13 3.27a3.79 3.79 0 105.61 2.41h7.5a3.87 3.87 0 00-.11.89 3.81 3.81 0 103.81-3.81H22.75l.83-.86a1.71 1.71 0 01.11-.14zM21.05 37a.9.9 0 11-1.36-.77l.32-.07.22-.05h.07a.89.89 0 01.75.89zm14 .9a.9.9 0 01-.15-1.79h.22a.9.9 0 01-.06 1.8z"
        fill="#242424"
      />
      <g data-name="Group 1029">
        <g data-name="Ellipse 66">
          <circle
            data-name="Ellipse 67"
            cx={40.5}
            cy={15.5}
            r={6.5}
            fill="#fff"
          />
        </g>
        <g data-name="Group 1172">
          <g data-name="Group 1171">
            <g data-name="Group 1175">
              <path
                data-name="Path 3037"
                d="M41.48 17h2.27a1.15 1.15 0 100-2.3h-2.27v-2.31a1.16 1.16 0 00-1.09-1.21 1.14 1.14 0 00-1.21 1.09.28.28 0 000 .13v2.26h-2.27a1.15 1.15 0 000 2.3h2.26v2.26a1.15 1.15 0 002.3 0z"
                fill="#242325"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
